import { InjectableClass } from '@fino/lib-injection';

const SnippetUrl = {
  testing: 'https://cdn.walkme.com/users/fb1d579fe5624a84b4580d83ad7f8660/test/walkme_fb1d579fe5624a84b4580d83ad7f8660_https.js',
  production: 'https://cdn.walkme.com/users/fb1d579fe5624a84b4580d83ad7f8660/walkme_fb1d579fe5624a84b4580d83ad7f8660_https.js'
};

export class WalkMeSnippetService extends InjectableClass {
  constructor(angularLoad, envService, $window, $log) {
    'ngInject';
    super({ angularLoad, envService, $window, $log });
  }

  activate() {
    // Activate smartLoad flag for walkme config
    this.$window._walkmeConfig = { smartLoad: true };

    // Load snippet by environment specific url
    const url = this.getSnippetUrl();
    this.angularLoad.loadScript(url).then(() => {
      this.$log.debug('walkme snippet loaded');
    });
  }

  getSnippetUrl() {
    if (this.envService.isProduction()) {
      return SnippetUrl.production;
    }
    return SnippetUrl.testing;
  }
}
